import React from "react";
import { Box, Card, Divider, Typography } from "@mui/material";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DescriptionIcon from "@mui/icons-material/Description";
import NumbersIcon from "@mui/icons-material/Numbers";
import InfoField from "./info-field";
import { FieldInfoCardProps } from "./types";
import { formatTitle } from "../../utils/string-formatters";

/**
 * FieldInfoCard displays metadata about a selected field including:
 * - Type (data type)
 * - Template (with optional dropdown for multiple templates)
 * - Record count
 *
 * Provides a clean, card-based interface for viewing and managing field information.
 */
const FieldInfoCard: React.FC<FieldInfoCardProps> = ({
  title,
  type,
  template,
  records,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 3,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {formatTitle(title)}
        </Typography>

        <Divider orientation="vertical" flexItem />

        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            flexWrap: "wrap",
            alignItems: "center",
            flex: 1,
          }}
        >
          <InfoField
            label="Template"
            value={template}
            icon={<DescriptionIcon />}
          />

          <InfoField label="Data Type" value={type} icon={<DataObjectIcon />} />

          <InfoField label="Records" value={records} icon={<NumbersIcon />} />
        </Box>
      </Box>
    </Card>
  );
};

export default FieldInfoCard;
